import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../base-data-services/data.service";
import { zoneListModel } from "common/models/page-models/custom-model/zone.mdel";



@Injectable()
export class zoneListDataService extends DataService<zoneListModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.zoneList,http);
    }


//    override getAPI_URL(): API_URL {
//         return API_URL.getDocumentTypeList;
//       }
    
    createInstance():zoneListModel  {
        return new zoneListModel();
    }

}
